import * as React from 'react';
import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';
import { ReportRow, ReportType } from '../../../models/reportOverviewRow';


interface Props {
  row: ReportRow;
  type: ReportType;
  setOpenRowId: (id: number | null) => void;
  setOpenType: (type: ReportType) => void;
  onClick: () => void;
}

const GenerateReportButton = ({ row, type, setOpenRowId, setOpenType, onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="text"
      size="medium"
      startIcon={<AddIcon />}
      sx={{ padding: '10px 8px' }}
      onClick={(e) => {
        e.stopPropagation();
        setOpenType(type);
        setOpenRowId(row.id);
        onClick();
      }}
    >
      <Typography variant="body2" fontWeight={600}>
        {type === 'Manual' && (process.env.REACT_APP_ENABLE_DOWNLOADER_SCHEDULED_FEATURE === 'true' ? t('screens.dataDownloader.manualChip') : t('screens.dataDownloader.generate'))}
        {type === 'Scheduled' && t('screens.dataDownloader.scheduledChip')}
      </Typography>
    </Button>
  );
};

export default GenerateReportButton;
